<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :hasInstructions="instruction ? true : false"
    :instructionPictures="instruction.pictures"
    :instructionText="instruction.text"
    :instructionTitle="instruction.title"
  >
    <file-upload-preview
      :example="example"
      :displayFiles="files"
      :asset="asset"
      :instruction="instruction"
      :onDelete="handleDelete"
      :onUpload="handleUpload"
    />
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IViewImageUploadable } from "@/lib/interfaces/Report/IViewImageUploadable";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportImageSubmission from "@/mixins/ReportImageSubmissionMixin.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import FileUploadPreview from "@/components/utility/FileUploadPreview.vue";

@Component({
  components: {
    LayoutReportStep,
    FileUploadPreview
  }
})
export default class ReportFrontTruckImage extends ReportImageSubmission implements IReportStep, IViewImageUploadable {
  public example = AssetEnum.truckFrontSilhouette;
  asset = AssetEnum.truckFrontSilhouetteOutline;

  screen = ReportScreenEnum.fronttruck;

  header: IReportHeaderData = {
    title: "report.imageFrontTruck.title",
    description: "report.imageFrontTruck.description",
    image: AssetEnum.truckFrontSilhouette,
    debug: this.files
  };

  instruction: IReportInstructionData = {
    title: "report.imageFrontTruck.title",
    text: "report.imageFrontTruck.instructionText",
    pictures: [AssetEnum.truckFrontSilhouette],
    example: AssetEnum.truckFrontSilhouette,
    display: true
  };

  async handleUpload(file: File): Promise<boolean> {
    await ReportModule.addDamage(file);
    return true;
  }

  async handleDelete(file: File): Promise<boolean> {
    return await ReportModule.removeDamage(file);
  }

  get files(): IImageUploaded[] {
    return ReportModule.damages;
  }
}
</script>
